import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import ListOfImageDesc from './ImageGallery/ListOfImgDesc';

const ImageWithDescContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Gallery Grid With Description' parent='Gallery' title='Gallery Grid With Description' />
      <Row>
        <ListOfImageDesc />
      </Row>
    </Container>
  );
};
export default ImageWithDescContainer;
